// Tableau de relecture des propositions et compte rendu de la dernière série.
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { useCatalogage } from '../../api/catalogage.js';
import { galerieALaction, galerieAModule } from '../../auth/sujet.js';
import { useShellContext } from '../shell/context.js';
import { NotFoundPage } from '../introuvable/NotFoundPage.js';
import styles from './Catalogage.module.css';

export function CatalogagePage() {
  const { galerie } = useShellContext();
  if (!galerieAModule(galerie, 'catalogage-image') || !galerieALaction(galerie, 'artworks:read'))
    return <NotFoundPage />;
  return <Tableau />;
}

function Tableau() {
  const { t } = useTranslation('regie');
  const { galerieSlug } = useShellContext();
  const tableau = useCatalogage(galerieSlug);
  const serie = tableau.data?.serie;
  const propositions = tableau.data?.propositions ?? [];
  return (
    <div className={styles.bloc}>
      <h1>{t('catalogage.titre')}</h1>
      <p>{t('catalogage.aide')}</p>
      <Link to={`/${galerieSlug}/oeuvres`}>{t('catalogage.choisirSerie')}</Link>
      {tableau.isError && <p role="alert">{t('catalogage.echec')}</p>}
      {tableau.isPending && <p>{t('catalogage.enCours')}</p>}
      {serie && (
        <section aria-label={t('catalogage.serie')}>
          <h2>{t('catalogage.serie')}</h2>
          <p>{t(`catalogage.series.${serie.etat}`)}</p>
          <p>{t('catalogage.compteurs', serie)}</p>
          {serie.cause && (
            <p role="status">
              {t(`catalogage.causes.${serie.cause}`, {
                defaultValue: t('catalogage.indisponible'),
              })}
            </p>
          )}
        </section>
      )}
      <h2>{t('catalogage.aRelire')}</h2>
      {!tableau.isPending && propositions.length === 0 && <p>{t('catalogage.vide')}</p>}
      <ul>
        {propositions.map((p) => (
          <li key={p.id}>
            <Link
              to={`/${galerieSlug}/${p.artisteId ? 'artistes' : 'oeuvres'}/${p.artisteId ?? p.oeuvreId}`}
            >
              {t(`catalogage.${p.type}`)} ·{' '}
              {tableau.data?.libelles?.[p.artisteId ?? p.oeuvreId ?? ''] ??
                t(p.artisteId ? 'catalogage.ficheArtiste' : 'catalogage.ficheOeuvre')}
            </Link>
            {' · '}
            {t(`catalogage.etats.${p.etat}`)}
          </li>
        ))}
      </ul>
    </div>
  );
}
